module.exports = __webpack_public_path__ + "img/btn_menu-close.b305266a.png";